export default __webpack_public_path__ + "2de6dc6f84532d78a09cf2552f6ca8c4.svg";